/**
 * @generated SignedSource<<3c39e296e1a4851f56626a7919b6dfd6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
import { FragmentRefs } from "relay-runtime";
export type MeetingLink_meeting$data = {
  readonly calendar: {
    readonly id: string;
  };
  readonly end: string | null;
  readonly guid: string;
  readonly id: string;
  readonly isAllDay: boolean;
  readonly isHidden: boolean | null;
  readonly isOrganizer: boolean | null;
  readonly note: {
    readonly finished: boolean;
    readonly stream: {
      readonly hasExternalUsersOrHasRelatedExternalStreams: boolean;
      readonly id: string;
      readonly latestNoteEditedAt: string | null;
      readonly viewerLastSeenAt: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"GroupsMenu_stream">;
    };
  } | null;
  readonly start: string | null;
  readonly title: string;
  readonly type: EventType;
  readonly " $fragmentSpreads": FragmentRefs<"RecordIcon_event">;
  readonly " $fragmentType": "MeetingLink_meeting";
};
export type MeetingLink_meeting$key = {
  readonly " $data"?: MeetingLink_meeting$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingLink_meeting">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingLink_meeting",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isHidden",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrganizer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "start",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "end",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAllDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "note",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "finished",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteStream",
          "kind": "LinkedField",
          "name": "stream",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "GroupsMenu_stream"
            },
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerLastSeenAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "latestNoteEditedAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasExternalUsersOrHasRelatedExternalStreams",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Calendar",
      "kind": "LinkedField",
      "name": "calendar",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordIcon_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "2d17ef3ee4f7d60f437ee4021da12026";

export default node;
